// extracted by mini-css-extract-plugin
export var container = "ConceptDetailsSubForm-module__container___+TUPT";
export var dynamicContainer = "ConceptDetailsSubForm-module__dynamicContainer___YIRir";
export var large = "1084px";
export var medium = "860px";
export var small = "540px";